// Components/TaxData.jsx
export const taxColumns = [
  { Header: "S.No", accessor: "sno" },
  { Header: "Name", accessor: "name" },
  { Header: "Percentage", accessor: "percentage" },
  { Header: "Type", accessor: "type" },
  { Header: "Actions", accessor: "actions" },
];
